function int_compare(e, r) {
  if (e < r) {
    return -1;
  } else if (e === r) {
    return 0;
  } else {
    return 1;
  }
}

function bool_compare(e, r) {
  if (e) {
    if (r) {
      return 0;
    } else {
      return 1;
    }
  } else if (r) {
    return -1;
  } else {
    return 0;
  }
}

function string_compare(e, r) {
  if (e === r) {
    return 0;
  } else if (e < r) {
    return -1;
  } else {
    return 1;
  }
}

function int_max(e, r) {
  if (e > r) {
    return e;
  } else {
    return r;
  }
}

export { int_max as a, bool_compare as b, int_compare as i, string_compare as s };
